import { Skeleton } from 'antd';
import React, { FC, ReactNode, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

interface InfiniteGridProps {
  children: ReactNode[];

  onPagination?: () => void;
  isLoading?: boolean;
  hasMore?: boolean;
}

const InfiniteGrid: FC<InfiniteGridProps> = ({
  children,

  onPagination,
  isLoading = false,
  hasMore = true,
}) => {
  const { ref, inView } = useInView({ threshold: 0 });

  useEffect(() => {
    if (inView && hasMore && !isLoading) {
      onPagination?.();
    }
  }, [inView, hasMore, isLoading]);

  return (
    <div className='text-white '>
      <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-x-2 gap-y-3'>
        {children}
      </div>

      <div ref={ref} className='h-10 mt-6  flex justify-center items-center'>
        {isLoading && <Skeleton active />}
      </div>
    </div>
  );
};

export default InfiniteGrid;
